class LocalizationForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.input = this.querySelector('.input-locale');

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
        event.preventDefault();
        this.input.value = event.currentTarget.dataset.value;
        if (this.form) this.form.submit();
    }
}


customElements.define('localization-form', LocalizationForm);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
    });
  }
  expandShowMore(event) {
    const parentDisplay = event.target.closest('.sidebar-body');
    parentDisplay.classList.toggle('active')
  }
}

customElements.define('show-more-button', ShowMoreButton);

function customAccordion(){
  let toggleBtn = document.querySelectorAll('.single_toggle .toggler');
  toggleBtn.forEach(button => {
    let thisBtn = button;
    button.addEventListener('click', () => {
      thisBtn.closest('.single_toggle').classList.toggle('active_tc');
      thisBtn.closest('.av_toggle_section')?.classList.toggle('active');
    })
  })
}

customAccordion();
